var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLk = function SvgLk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M9.391 2.086H5.237c-.184.126-.365.257-.541.393l-1.044 9.52 1.044 9.52c.176.136.357.267.54.393h4.155V2.086Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M0 12a11.98 11.98 0 0 0 4.696 9.521V2.481A11.98 11.98 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.305 7.315v.3l.01.003-.01-.303Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M23.043 15.13h-2.26l-.957 1.043v2.087h-2.087v-1.043h1.043V15.13h-4.696v1.304h-1.043v-2.486a1.56 1.56 0 0 1-.522-1.166V5.999c0-.864.701-1.565 1.565-1.565v9.652h2.087l.717-.597a2.495 2.495 0 0 1-.195-.968v-1.565H15.13v-3.13h3.13c0-.522.783-1.044.783-1.044s.783.522.783 1.043v3.131c.58.007 1.502-.008 2.499 0-.262-.458-.412-1-.412-1.565 0-.921.397-1.749 1.03-2.322a12.048 12.048 0 0 0-4.18-4.983h-7.807v19.826h7.807a12.027 12.027 0 0 0 4.693-6.332l-.413-.45Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgLk;